import { ContextualBanner, Heading } from '@hawkins/components';
import { Dimensions } from '@hawkins/variables';
import { Grid } from 'src/domains/shared/components/Grid';
import { NetflixUHDBanner } from './NetflixUHDBanner';
import { OutputProperty } from './OutputProperty';
import { resolutionAsText } from './outputUtils';
import { Resolution } from 'src/domains/calculators/utilities/types';
import { FramingAndWorkingResolutionOutputProps } from './types';
import { Coordinates } from '../FramingChart/types';

export const FramingAndWorkingResolutionOutput = ({
  framingDecision,
  framingDecisionCoordinates,
  framingAndWorkingProps,
  sensorResolution,
}: {
  framingDecision: Resolution;
  framingDecisionCoordinates: Coordinates;
  framingAndWorkingProps: FramingAndWorkingResolutionOutputProps;
  sensorResolution: Resolution;
}) => {
  return (
    <>
      <Heading align="center">Framing Resolution</Heading>

      <Grid gap={Dimensions.Space10}>
        <NetflixUHDBanner
          approved={framingAndWorkingProps.approvedForNetflixUHD}
        />
        <OutputProperty
          label={'Canvas Dimensions'}
          value={resolutionAsText(sensorResolution)}
        />
        <OutputProperty
          label="Canvas Aspect Ratio (squeezed)"
          value={`${framingAndWorkingProps.sensorAspectRatio[0]} : ${framingAndWorkingProps.sensorAspectRatio[1]}`}
        />
        <OutputProperty
          label="Canvas Aspect Ratio (desqueezed)"
          value={`${framingAndWorkingProps.contentAspectRatio[0]} : ${framingAndWorkingProps.contentAspectRatio[1]}`}
        />
        <OutputProperty
          label={'Framing Decision'}
          value={resolutionAsText(framingDecision)}
        />
        <OutputProperty
          label="Anchor Point"
          value={`X: ${framingDecisionCoordinates.x}, Y: ${framingDecisionCoordinates.y}`}
        />
        <OutputProperty
          label="Resizing beyond this is no longer Netflix compliant"
          value={`${
            framingAndWorkingProps.maximumAllowedResizeInPost
          }% (${resolutionAsText(
            framingAndWorkingProps.maximumAllowedSensorCrop
          )})`}
        />
      </Grid>
      <Heading align="center">Working Resolution</Heading>
      <ContextualBanner
        text="Resolutions in the below assume desqueezed images."
        variant="warning"
      />
      <Grid gap={Dimensions.Space10}>
        <OutputProperty
          label={'Minimum Netflix Compliant IMF Extraction'}
          value={resolutionAsText(
            framingAndWorkingProps.imfActiveImageResolution
          )}
        />
        <OutputProperty
          label="Dailies Active Image Resolution"
          value={resolutionAsText(
            framingAndWorkingProps.dailiesActiveImageResolution
          )}
        />
        <OutputProperty
          label="Working Resolution (Proposed)"
          value={resolutionAsText(
            framingAndWorkingProps.preferredWorkingResolution
          )}
        />
        <OutputProperty
          label="Working Resolution (Minimum)"
          value={resolutionAsText(
            framingAndWorkingProps.minimumWorkingResolution
          )}
        />
      </Grid>
    </>
  );
};
